"use client";

import { useMemo } from "react";
import ItemCard from "@/components/ItemCard";
import SelectionCard from "@/components/SelectionCard";
import GhostCard from "../GhostCard";

import styles from "./styles.module.scss";
import { Box as MantineBox, Title as MantineTitle } from "@mantine/core";

type Props = {
  items: SearchResultItem[];
  loading: boolean;
  ghosts?: number;
  noResults?: boolean;
  cart?: boolean;
  handleCardClick?: (id: number) => void;
  showProAd?: boolean;
  priceHasCurrency?: boolean;
  disableFavorites?: boolean;
  enableImageSearch?: boolean;
  enablePriceMonitor?: boolean;
};

const CardGrid = ({
  items,
  loading,
  ghosts = 20,
  cart,
  handleCardClick,
  noResults = false,
  priceHasCurrency = false,
  disableFavorites = false,
  enableImageSearch = false,
  enablePriceMonitor = false,
}: Props) => {
  const onClick = handleCardClick || (() => {});
  const GhostCards = Array.from({ length: ghosts }).map((_, i) => (
    <GhostCard key={`ghost-${i}`} index={i} />
  ));

  const productCards = useMemo(() => {
    // if (!showProAd) {
    return items;
    // }
    // Temp disabled becuase it looks a bit jank
    // // slice a pro ad card every 50 items
    // return items.reduce((acc: SearchResultItem[], item, index) => {
    //   acc.push(item);
    //   if ((index + 1) % 50 === 0) {
    //     const proImageIndex = (Math.floor(index / 5) % 3) + 1;
    //     acc.push({
    //       id: 0,
    //       title: "Upgrade to KURB Pro",
    //       description: `
    //       <h4>Unlock Saved filter notifications across devices and early access to new features.</h4>
    //       <ul>
    //         <li>Early access to new features</li>
    //         <li>Customizable notification settings</li>
    //         <li>Create up to 10 saved filters</li>
    //         <li>Push notification updates for your saved filters</li>
    //         <li>Email summary of new listings</li>
    //       </ul>
    //       </br >
    //       <strong>Upgrade to KURB Pro for just $48USD/year or $6USD paid monthly</strong>
    //       `,
    //       imageurl: `/pro-${proImageIndex}.jpg`,
    //       url: "/plans",
    //       itemurl: "/plans",
    //       region: "Global",
    //       price: "$4 USD/month*",
    //       whenAdded: "lean more",
    //       currency: "",
    //       vendorname: "KURB",
    //       vendor: {
    //         label: "KURB",
    //         id: 0,
    //       },
    //       brand: {
    //         label: "KURB",
    //         id: 0,
    //       },
    //     } as unknown as SearchResultItem);
    //   }
    //   return acc;
    // }, []);
  }, [items]);

  return (
    <MantineBox className={styles.cardGrid} data-noresults={noResults}>
      <MantineBox className={styles.gridContainer} id="masonaryContainer">
        {noResults ? (
          <MantineTitle order={2}>NO RESULTS FOUND</MantineTitle>
        ) : !items.length ? (
          GhostCards
        ) : (
          productCards.map((item, i) =>
            cart ? (
              <SelectionCard key={`${item.id}-${i}`} item={item} removeSelection={onClick} />
            ) : (
              <ItemCard
                key={`${item.id}-${i}`}
                item={item}
                priceHasCurrency={priceHasCurrency}
                disableFavorites={disableFavorites}
                enableImageSearch={enableImageSearch}
                enablePriceMonitor={enablePriceMonitor}
                favoriteId={
                  (item as { favoriteId?: number; favorite_id?: number }).favoriteId ??
                  (item as { favorite_id?: number }).favorite_id
                }
              />
            )
          )
        )}
        {!noResults && loading && GhostCards}
      </MantineBox>
    </MantineBox>
  );
};

export default CardGrid;
